"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupStyles = setupStyles;
exports.setupTables = setupTables;
const linkedStyles_1 = require("@front/styles/linkedStyles");
const client_1 = require("@rws-framework/client");
function setupStyles() {
    if (localStorage.getItem('app.dark_mode') === '1') {
        linkedStyles_1.linkedStyles.push('/assets/css/dark.chunk.css');
    }
    client_1.RWSViewComponent.injectStyles(linkedStyles_1.linkedStyles);
}
function setupTables() {
}
